import { Component, Input, Output, EventEmitter, AfterViewInit, ComponentFactoryResolver, ViewContainerRef, Injector, ComponentRef } from "@angular/core";
import { Note } from "ng/src/app/notes/shared/note.model";
import { NoteAcknowledgementsService } from "ng/src/app/notes/note-acknowledgements/note-acknowledgements.service";
import { Utils } from "ng/src/app/core/utils";
import { finalize } from "rxjs/operators";
import { NoteDisplayComponent } from "ng/src/app/notes/note-display/note-display.component";
@Component({
	selector: 'note-acks',
	templateUrl: './note-acks.component.html',
	styleUrls: ['./note-acks.scss']
})
export class NoteAcksComponent implements AfterViewInit {
	@Input() notes: Note[] = []
	@Output('notesCompleted') completed = new EventEmitter();

	updatePending = false;
	private noteDisplayRef?: ComponentRef<NoteDisplayComponent>;
	
	get note() {
		return this.notes[0];
	}
	
	constructor(
		private ackService: NoteAcknowledgementsService,
		private factoryResolver: ComponentFactoryResolver
	) {}
	
	ngAfterViewInit(): void {
		if (this.notes.length === 0) {
			this.completed.next()
		}
		
		this.notes.forEach(n => n.noteComments.sort(Utils.createSortFunction(nc => new Date(nc.updated))));
	}
	
	acknowledge(note: Note) {
		this.updatePending = true;
		this.ackService.acknowledgeNote(note)
			.pipe(
				finalize(() => this.updatePending = false)
			)
			.subscribe(() => {
				this.notes.splice(this.notes.indexOf(note), 1);
				if (this.notes.length === 0) {
					this.completed.next();
				}
				else if (this.noteDisplayRef) {
					this.setNoteInDisplay();
				}
			})
	}
	
	
	setupNoteViewContainer(viewRef: ViewContainerRef) {
		// creates a note display ref through the ViewContainer due to circular dependency issue with note module
		this.noteDisplayRef = viewRef.createComponent(this.factoryResolver.resolveComponentFactory(NoteDisplayComponent));
		this.noteDisplayRef.instance.applyStyles = 'tagsOnly';
		this.setNoteInDisplay();
	}
	
	setNoteInDisplay() {
		if (!this.noteDisplayRef) throw new Error('Note Display Ref is not set');
		this.noteDisplayRef.instance.note = this.note;
		this.noteDisplayRef.changeDetectorRef.detectChanges();
	}
	
}